import { RotateCw } from "lucide-react";
import { Button } from "../ui/Button";
import { Modal } from "../ui/Modal";

export function RestartConfirmationModal({
  busy,
  onConfirm,
  onClose,
}: {
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal
      title="Změna vyžaduje restart VPS"
      description="Aby se změna stala platnou, musíme VPS restartovat."
      onClose={onClose}
      footer={<><Button variant="ghost" disabled={busy} onClick={onClose}>Storno</Button><Button variant="primary" icon={<RotateCw />} busy={busy} onClick={onConfirm}>Souhlasím</Button></>}
    >
      <div className="info-box"><RotateCw /><p>Během restartu bude VPS offline po dobu několika sekund. Zastavení VPS může trvat i několik minut, pokud jej komplikuje nějaký interní proces nebo služba ve VPS.</p></div>
    </Modal>
  );
}
